/**
 * Gizli maliyet alanına (baseUnitCost) kullanıcı tarafından değer girilmiş mi?
 * fabricCost otomatik doldurma fallback'i sayılmaz.
 */
export const hasExplicitHiddenUnitCost = (order) => {
  if (!order) return false;
  const raw = order.baseUnitCost;
  return raw !== undefined && raw !== null && String(raw).trim() !== '';
};

/**
 * Sipariş için birim maliyet: yalnızca gizli maliyet + manuel ek maliyet.
 * Gizli maliyet girilmediyse 0.
 */
export const resolveOrderUnitCost = (order) => {
  if (!order) return 0;
  const base = hasExplicitHiddenUnitCost(order) ? (parseFloat(order.baseUnitCost) || 0) : 0;
  const manualExtra = parseFloat(order.manualExtraCost) || 0;
  return base + manualExtra;
};

/**
 * Sipariş toplam maliyetini çözümler.
 * Gizli maliyet yoksa 0 döner (net kazanç = ciro - 0).
 */
export const resolveOrderTotalCost = (order) => {
  if (!order) return 0;

  if (
    order.productType === 'plise' &&
    Array.isArray(order.pliseItems) &&
    order.pliseItems.length > 0 &&
    (parseFloat(order.pliseProduct1Cost) > 0 || parseFloat(order.pliseProduct2Cost) > 0)
  ) {
    const c1 = parseFloat(order.pliseProduct1Cost) || 0;
    const c2 = parseFloat(order.pliseProduct2Cost) || 0;
    const mCost = parseFloat(order.mountingCost) || 0;
    const gQty = parseFloat(order.quantity) || 1;
    let costSum = 0;
    order.pliseItems.forEach((item) => {
      const m2 = parseFloat(item.usedM2) || 0;
      const qty = parseFloat(item.quantity) || 1;
      const unitCost = c1 + (item.multisistem ? c2 : 0);
      costSum += m2 * unitCost * qty;
    });
    return (costSum + mCost) * gQty;
  }

  const qty = parseFloat(order.quantity) || 1;
  const unitCost = resolveOrderUnitCost(order);

  if (order.productType === 'tul' || order.productType === 'kanat') {
    const storedTotal = parseFloat(order.totalCost);
    if (
      order.productType === 'kanat' &&
      order.hasKanatAstar &&
      order.totalCost !== undefined &&
      order.totalCost !== null &&
      order.totalCost !== '' &&
      Number.isFinite(storedTotal) &&
      storedTotal > 0
    ) {
      return storedTotal;
    }

    const widthM = parseFloat(order.width) || 0;
    let baseCost = 0;
    if (widthM > 0) {
      baseCost = widthM * unitCost * qty;
    } else {
      const usedM2 = parseFloat(order.usedM2) || 0;
      if (usedM2 > 0) {
        baseCost = usedM2 * unitCost * qty;
      }
    }

    if (order.productType === 'kanat' && order.hasKanatAstar) {
      const astarStored = parseFloat(order.astarCost);
      if (Number.isFinite(astarStored) && astarStored > 0) {
        return baseCost + astarStored;
      }
      const meters = parseFloat(order.usedM2) || 0;
      const astarUnitCost = parseFloat(order.astarUnitCost) || 0;
      return baseCost + (meters * astarUnitCost * qty);
    }

    return baseCost;
  }

  if (hasExplicitHiddenUnitCost(order) || (order.manualExtraCost !== undefined && order.manualExtraCost !== null && String(order.manualExtraCost).trim() !== '')) {
    const stored = parseFloat(order.totalCost);
    if (order.totalCost !== undefined && order.totalCost !== null && order.totalCost !== '' && Number.isFinite(stored)) {
      return stored;
    }
  }

  const stored = parseFloat(order.totalCost);
  if (
    order.totalCost !== undefined &&
    order.totalCost !== null &&
    order.totalCost !== '' &&
    Number.isFinite(stored) &&
    stored > 0
  ) {
    return stored;
  }

  return 0;
};
